import React, { memo } from 'react';
import { Close } from '@mui/icons-material';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography
} from '@mui/material';
import { BatchSizeLimitDialogProps } from 'models';
import { dialog as dialogColors } from 'theme/colors';

export const BatchSizeLimitDialog = memo(
	({
		open,
		onClose,
		title,
		messages,
		confirmLabel
	}: BatchSizeLimitDialogProps) => (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			sx={{ zIndex: 99999, '& .MuiDialog-paper': { bgcolor: dialogColors.paper } }}
		>
			<DialogTitle sx={{ pr: 6, mb: 2, display: 'block' }}>
				<Typography
					sx={{ fontSize: '20px', fontWeight: 400, lineHeight: '28px' }}
				>
					{title}
				</Typography>
				<IconButton
					aria-label="close"
					onClick={onClose}
					size="small"
					sx={{ position: 'absolute', right: 8, top: 8 }}
				>
					<Close fontSize="small" />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				{messages.map((msg, idx) => (
					<Typography
						// eslint-disable-next-line react/no-array-index-key
						key={idx}
						variant="body2"
						gutterBottom={idx !== messages.length - 1}
						sx={{
							...(idx !== messages.length - 1 && { marginBottom: '16px !important' }),
							fontSize: '16px',
							fontWeight: 400,
							lineHeight: '20px'
						}}
					>
						{msg}
					</Typography>
				))}
			</DialogContent>
			<DialogActions sx={{ px: 2, pb: 2 }}>
				<Button variant="contained" color="primary" onClick={onClose} sx={{ fontSize: '14px', fontWeight: 500, lineHeight: '24.5px' }}>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	)
);

export default BatchSizeLimitDialog;
